import { hotelStatuses } from 'main/hotelStatuses'
import moment from 'moment'

/**
 * Builds PATCH merchants/subsidiary/status payload.
 * @param {{ reason: string, status: string, churnedDate?: Date | null }} params
 */
export function buildStatusUpdatePayload({ reason, status, churnedDate }) {
  const payload = { reason, status }
  if (status === hotelStatuses.Churned && churnedDate) {
    payload.churnedEffectiveDate = moment(churnedDate).format('YYYY-MM-DD')
  }
  return payload
}
